let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b25ru")).then(() => parcelRequire('4UTDD'));